/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { loadAuthMode } from './context/vault';
import { useTracked } from './state';

const AuthLoader: React.FC = () => {
    const [, dispatch] = useTracked();

    React.useEffect(() => {
        sessionCheck();

    }, []);

    const sessionCheck = async () => {
        const { authMode, biometricType, hasSession, biometricsSupported  } = await loadAuthMode();
        dispatch({ type: 'setVaultAuth', authMode, biometricType, hasSession, biometricsSupported })
    };

    return <> </>;
}

export default AuthLoader;